export const pickupTypes = {
    total: "total-pickup",
    itemized: "itemized-pickup",
    unset: "unset",
};